import { useState } from "react";
import { silverData } from "../data/silverData";
import SearchBar from "../components/Searchbar";
import Filters from "../components/Filters";
import SortMenu from "../components/SortMenu";
import ProductCard from "../components/ProductCard";
import ProductModal from "../components/ProductModal";
import FloatingFilterBar from "../components/FloatingFilterBar";

export default function SilverCollection() {
  
  const [search, setSearch] = useState("");
  const [material, setMaterial] = useState("");
  const [sort, setSort] = useState("");
  const [favourites, setFavourites] = useState([]);
  const [modalItem, setModalItem] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [showSort, setShowSort] = useState(false);

  const toggleFav = (id) => {
    setFavourites((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const openModal = (item) => setModalItem(item);
  const closeModal = () => setModalItem(null);

  // Search + filter
  let products = silverData.filter((i) =>
    i.name.toLowerCase().includes(search.toLowerCase())
  );

 if (material) {
  products = products.filter((i) =>
    i.material.toLowerCase().trim() === material.toLowerCase().trim()
  );
}


  if (sort === "low") products.sort((a, b) => a.discountedPrice - b.discountedPrice);
  if (sort === "high") products.sort((a, b) => b.discountedPrice - a.discountedPrice);
  if (sort === "discount") products.sort((a, b) => b.discountPercent - a.discountPercent);

  return (
    <div className="pt-24 max-w-7xl mx-auto px-4 pb-28">
      <div className="flex flex-col md:flex-row items-center justify-between gap-3 md:gap-4">

        <div className="w-full md:w-1/2"><SearchBar search={search} setSearch={setSearch} /></div>
        <div className="flex gap-3">
          <Filters material={material} setMaterial={setMaterial} />
          <SortMenu sort={sort} setSort={setSort} />
        </div>
      </div>

      <div
  className="
    grid 
    grid-cols-2 
    sm:grid-cols-2 
    md:grid-cols-3 
    lg:grid-cols-4 
    gap-3 sm:gap-4 
    mt-6
  "
>


        {products.map(item => (
          <ProductCard
            key={item.id}
            item={item}
            openModal={openModal}
            toggleFav={toggleFav}
            favourites={favourites}
          />
        ))}
      </div>

      <FloatingFilterBar
        onOpenFilter={() => setShowFilters(true)}
        onOpenSort={() => setShowSort(true)}
      />

      {showFilters && (
        <div className="fixed inset-0 z-50 bg-black/30 flex items-end">
          <div className="bg-white w-full p-4 rounded-t-xl">
            <div className="flex justify-between items-center">
              <h3 className="font-bold">Filters</h3>
              <button onClick={() => setShowFilters(false)}>Close</button>
            </div>
            {/* Put your advanced filters here */}
            <div className="mt-4">Material: <Filters material={material} setMaterial={setMaterial} /></div>
          </div>
        </div>
      )}

      {showSort && (
        <div className="fixed inset-0 z-50 bg-black/30 flex items-end">
          <div className="bg-white w-full p-4 rounded-t-xl">
            <div className="flex justify-between items-center">
              <h3 className="font-bold">Sort</h3>
              <button onClick={() => setShowSort(false)}>Close</button>
            </div>
            <div className="mt-4"><SortMenu sort={sort} setSort={setSort} /></div>
          </div>
        </div>
      )}

      <ProductModal item={modalItem} close={closeModal} />
    </div>
  );
}
